{
  "version": 1,
  "asset_id": "bd328fb1-c698-4f90-b167-e30e982722db",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/bd328fb1-c698-4f90-b167-e30e982722db/floral-city-black-shingle-roof-installation-1320w.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/bd328fb1-c698-4f90-b167-e30e982722db/floral-city-black-shingle-roof-installation-1320w.avif",
  "original_filename": "floral-city-black-shingle-roof-installation-1320w.avif",
  "size": 61540,
  "content_type": "image/avif",
  "created_at": "2026-07-21T19:37:36Z"
}
